module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('router-link', {
    staticClass: "button is-fullwidth",
    attrs: {
      "to": {
        name: 'EmitentNewsCreator'
      }
    }
  }, [_vm._v("Добавить событие эмитента")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.deponentsDataCopy.length) ? _c('ul', {
    staticClass: "list"
  }, [_c('b-table', {
    attrs: {
      "html": "",
      "data": _vm.deponentsDataCopy,
      "bordered": false,
      "striped": false,
      "narrowed": false,
      "selectable": false,
      "checkable": true,
      "mobile-cards": false,
      "paginated": true,
      "per-page": 10,
      "render-html": ""
    },
    on: {
      "dblclick": _vm.edit,
      "check": _vm.checked
    }
  }, [_c('b-table-column', {
    attrs: {
      "field": "publishDate",
      "label": "Дата публикации",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "registryClippingDate",
      "label": "Дата отсечения реестра",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "eventDate",
      "label": "Дата события",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "eventEndDate",
      "label": "Дата события по",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "fixationDate",
      "label": "Дата фиксации",
      "sortable": "",
      "format": _vm.formatDate
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "eventTitle",
      "label": "Событие",
      "sortable": ""
    }
  }), _vm._v(" "), _c('b-table-column', {
    staticClass: "emitents-data",
    attrs: {
      "field": "data",
      "label": "Эмитенты",
      "sortable": "",
      "format": _vm.getName
    }
  })], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "disabled": !_vm.checkItems.length
    },
    on: {
      "click": _vm.del
    }
  }, [_vm._v("Удалить")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box interval-box"
  }, [_c('b-field', {
    attrs: {
      "type": _vm.intervalError && 'is-danger',
      "message": _vm.intervalError,
      "label": "Интервал сканирования (в минутах)"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "required": ""
    },
    model: {
      value: (_vm.interval),
      callback: function($$v) {
        _vm.interval = $$v
      },
      expression: "interval"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.interval
    },
    on: {
      "click": _vm.updateInterval
    }
  }, [_vm._v("Сохранить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae09c08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmitentNews/Index.vue
// module id = 916
// module chunks = 0